/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/




import Box from "components/generals/Box";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";
import BillingEncounterContent from "components/content/BillingEncounterContent";

/**
 * Billing encounter management page.
 * 
 * Features:
 * - List of all billing encounters with patient and provider details
 * - Encounter status tracking (draft, submitted, paid, denied)
 * - CPT code and procedure documentation
 * - Diagnosis code (ICD-10) association
 * - Insurance claim submission integration
 * - Payment tracking and reconciliation
 * - Encounter filtering by date, status, provider
 * 
 * @returns Billing encounters page component
 */
const BillingEncounterPage: FC = () => {
  return (
    <DefaultDashboardLayout>
      <Box>
        <BillingEncounterContent />
      </Box> 
    </DefaultDashboardLayout>
  );
};

export default BillingEncounterPage;
